module.exports = __webpack_public_path__ + "img/ban-bug.e47ed0d1.svg";